import { User } from "../../../../modules/authentication/domain";

export class OrganizationGroups {
  constructor(public readonly groups: Group[]) {}

  get allMembers(): GroupMember[] {
    return this.groups.flatMap((it) => it.members);
  }
}

export class Group {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly deskIsDedicatedForTeam: boolean,
    public readonly members: GroupMember[]
  ) {}
}

export class GroupMember {
  constructor(
    public readonly id: string,
    public readonly user: User,
    public readonly deskIsDedicatedToMember: boolean,
    public readonly groupName: string,
    public readonly groupId: string | null
  ) {}
}
